module.exports = __webpack_public_path__ + "static/media/caption.877364a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caption.svg
// module id = 1416
// module chunks = 0